<div class="layout">
  <div class="sidebar">
    <app-csidebar (tabSelected)="onTabSelected($event)"></app-csidebar>
  </div>

  <div class="main">
    <app-cmain [selectedTab]="selectedTab"></app-cmain>
  </div>
</div>
